import React, { CSSProperties, FunctionComponent } from 'react';
import classNames from 'clsx';

export interface ShimmerProps {
  className?: string;
  rounded?: string;
  style?: CSSProperties;
}

/**
 * Skeleton loading primitive — muted surface with a diagonal gradient sweep.
 * Sizing comes from `className` (height/width utilities). Corner radius via
 * `rounded` prop (default `rounded-md`).
 */
export const Shimmer: FunctionComponent<ShimmerProps> = ({
  className = '',
  rounded = 'rounded-md',
  style
}) => (
  <span
    className={classNames('frost-shimmer relative block overflow-hidden', rounded, className)}
    style={style}
    aria-hidden
  >
    <span className="frost-shimmer__sweep absolute inset-0 -translate-x-full" />
  </span>
);

export default Shimmer;
